import React from 'react';
import '../App.css';

const Landing = () => {
  return (
    <section id="landing" className="landing">
      <img src="avatar.png" alt="Avatar" className="avatar" />
      <h1>Ongun Akay</h1>
      <p>A frontend developer specialized in React.</p>
    </section>
  );
};

export default Landing;
